module.exports = __webpack_public_path__ + "img/ZW.0dea3282.png";